'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _reduxActions = require('redux-actions');

var _buildMessageKey = require('conversations-schema/pubnub-message/operators/buildMessageKey');

var _ThreadHistory = require('conversations-schema/thread-history/ThreadHistory');

var _ThreadHistory2 = _interopRequireDefault(_ThreadHistory);

var _ActivelyPublishing = require('conversations-schema/unpublished-messages/records/ActivelyPublishing');

var _ActivelyPublishing2 = _interopRequireDefault(_ActivelyPublishing);

var _stubbedThreadId = require('../../threads/constants/stubbedThreadId');

var _addMessageToThreadHistory = require('../../thread-histories/operators/addMessageToThreadHistory');

var _StubbedThreadHistoryActionTypes = require('../constants/StubbedThreadHistoryActionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = new _ThreadHistory2.default();

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _StubbedThreadHistoryActionTypes.STAGE_MESSAGE_ON_STUBBED_THREAD, function (state, action) {
  var message = action.payload.message;


  var messageKey = (0, _buildMessageKey.buildMessageKey)(message);

  return (0, _addMessageToThreadHistory.addMessageToThreadHistory)(messageKey, message, state);
}), _defineProperty(_handleActions, _StubbedThreadHistoryActionTypes.ADD_VISITOR_MESSAGE_TO_STUBBED_THREAD, function (state, action) {
  var message = action.payload.message;


  var messageKey = (0, _buildMessageKey.buildMessageKey)(message);

  var activelyPublishingMessage = new _ActivelyPublishing2.default({
    message: message,
    threadId: _stubbedThreadId.STUBBED_THREAD_ID
  });

  return (0, _addMessageToThreadHistory.addMessageToThreadHistory)(messageKey, activelyPublishingMessage, state);
}), _defineProperty(_handleActions, _StubbedThreadHistoryActionTypes.RESET_STUBBED_THREAD, function () {
  return initialState;
}), _handleActions), initialState);
module.exports = exports['default'];